/** Shared by OTP issuance and browser resend countdowns. Keep this module client-safe. */
export const EMAIL_OTP_RESEND_COOLDOWN_SECONDS = 60;
